var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools01-edit"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v(_vm._s(_vm.toolData.name2)+" 編集")])])],1),_c('PageEditor',{attrs:{"toolId":_vm.toolId,"pageId":_vm.pageId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }